type KnownQueryParemeter =
  | 'sort'
  | 'filterText'
  | 'quickFilter'
  | 'filterTags'
  | 'filterTechs'
  | 'filterLanguages'
  | 'filterServers'
  | 'filterCompliance'
  | 'filterVulnSeverities'
  | 'filterEnvironments'
  | 'filterApps'
  | 'applicationTags'
  | 'expand'
  | 'offset'
  | 'limit'
  | 'includeMerged'
  | 'includeModules'
  | 'q'
  | 'tags'
  | 'sourceNameIDs'
  | 'applicationsIds'
  | 'logLevels'
  | 'serverEnvironments'
  | 'agentVersions'
  | 'modules'
  | 'servers'
  | 'severities'
  | 'status'
  | 'substatus'
  | 'vulnTypes'
  | 'appVersionTags'
  | 'environments'
  | 'urls'
  | 'sinks'
  | 'securityStandards'
  | 'tracked'
  | 'untracked'
  | 'timestampFilter'
  | 'startDate'
  | 'endDate'
  | 'discoveredStartDate'
  | 'discoveredEndDate'
  | 'metadataFilters'
  | 'routes'
  | 'applicationID'
  | 'apps'
  | 'languages'
  | 'licenses'
  | 'applications'
  | 'attackers'
  | 'includeBotBlockers'
  | 'includeIpBlacklist'
  | 'includeSuppressed'
  | 'keyword'
  | 'results'
  | 'rules'
  | 'statuses'
  | 'interval'
  | 'componentHashes'
  | 'base'
  | 'grades'
  | 'sortBy'
  | 'sortDirection'
  | 'searchText'
  | 'includeUsed'
  | 'includeUnused'
  | 'exclusionType'
  | 'applicationIds'
  | 'agentSessionId'
  | 'environment'
  | 'appImportances'
  | 'vulnerabilityStatuses'
  | 'vulnerabilitySeverities'
  | 'vulnerabilityTypes'
  | 'vulnerabilityTags'
  | 'serverTags'
  | 'complianceReports'
  | 'showVulnerabilitiesDetails'
  | 'showRouteObservations'

export class ContrastQueryParameters {
  private readonly parameters: {
    [key: string]: Set<string>
  } = {}

  public append(
    key: KnownQueryParemeter,
    ...values: Array<string | number | boolean>
  ) {
    const uriKey = encodeURIComponent(key)
    if (!this.parameters[uriKey]) {
      this.parameters[uriKey] = new Set()
    }

    values.forEach((value) => {
      this.parameters[uriKey].add(encodeURIComponent(`${value}`))
    })
  }

  public toString() {
    return Object.keys(this.parameters).reduce((queryString, parameterName) => {
      const values = this.parameters[parameterName]
      const parameterString = `${parameterName}=`

      let valueString = queryString
      values.forEach((value) => {
        const previousValues = `${valueString}${valueString ? '&' : ''}`
        valueString = `${previousValues}${parameterString}${value}`
      })

      return valueString
    }, '')
  }
}
